import React, {useContext} from "react";
// my imports:
import { AnyGameObj } from "@/app/lib/game-state/game-types";
import { captureFocusedLetterBox } from "@/app/lib/input/capture-focused-letterBox";
import { handleBlurIngredientClick, handleFocusIngredientClick, handleIngredientBackSpace } from "@/app/lib/input/handle-ingredient-click";
import UI from "@/app/lib/ui/ui";
import { Contexts } from "@/app/components/Context";
// styles:
import styles from '@/app/styles/ingredients.module.css';
import animation from "@/app/styles/animation.module.css";

const DELAY = .04;

export default function Ingredients() {

    const activeGame: AnyGameObj | null = useContext(Contexts.ActiveGame);
    const ui: UI | null = useContext(Contexts.UI);

    if (!activeGame || !ui ) {
        console.warn('bad context in Ingredients');
        return;
    }

    let renderBackspaceButton: boolean = ui.isTouch;
    let focusedPosition: { wordIndex: number, letterPosition: number } | null = null;

    let ingredientsKey = '';
    for (const ingredient of activeGame.state.ingredients) {
        ingredientsKey += ingredient;
    }

    return (
        <div className={styles.ingredientsContainer} >
            <Letters 
                activeGame={activeGame}
                ui={ui}
                key={ingredientsKey}
            />
            {renderBackspaceButton &&
                <button
                    className={`${styles.ingredientsButton} ${animation.fadeIn} ${animation.fast}`}

                    style={{animationDelay: `${DELAY * activeGame.state.ingredients.length}s`}}

                    onPointerDown={() => 
                        focusedPosition=captureFocusedLetterBox()
                    }

                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (focusedPosition) {
                            handleIngredientBackSpace({
                                wordIndex: focusedPosition.wordIndex,
                                letterPosition: focusedPosition.letterPosition,
                                game: activeGame,
                                ui
                            })
                        }
                    }}
                >
                    ⌫
                </button> 
            }

            <button
                className={`${styles.ingredientsButton} ${animation.fadeIn} ${animation.fast}`}

                style={{animationDelay: `${DELAY * activeGame.state.ingredients.length}s`}}

                onPointerDown={() =>
                    focusedPosition=captureFocusedLetterBox()
                }

                onClick={(e) => {
                    e.stopPropagation();
                    activeGame.update(state => state.shuffle());
                    if (focusedPosition) {
                        ui.focus(focusedPosition);
                    }
                }}
            >
               ↻
            </button>
        </div>
    );    
}

type IngredientProps = {
    activeGame: AnyGameObj,
    ui: UI
}

function Letters({ activeGame, ui }: IngredientProps) {

    let focusedPosition: { wordIndex: number, letterPosition: number } | null = null;

    return(
        <>
            {activeGame.state.ingredients.map((letter, index) =>
            <div
                className={`
                    ${styles.ingredientsBox}
                    ${animation.fadeIn}
                    ${animation.fast}
                `}
                style={{animationDelay: `${DELAY * index}s`}}

                key={index}

                onPointerDown={() =>
                    focusedPosition=captureFocusedLetterBox()
                }

                ref={(el) => ui.setIngredientRef(index, el)}

                onClick={(e) => {
                    e.stopPropagation();
                    if (!focusedPosition) {
                        handleBlurIngredientClick({
                            letter,
                            game: activeGame,
                            ui,
                        })
                        return;
                    }
                    handleFocusIngredientClick({
                        letter,
                        wordIndex: focusedPosition.wordIndex,
                        letterPosition: focusedPosition.letterPosition,
                        game: activeGame,
                        ui,
                    })
                }}
            >
                    {letter.toUpperCase()}
            </div>
            )}
        </>
    )
}